import {FETCH_TAG_INFO, FETCH_TAX_ID} from '../actions';

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_TAG_INFO:
            return action.payload;
		case FETCH_TAX_ID:
			return action.payload;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/tag-reducer.js